import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomTwitterReply = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>
        <path d="M1.75098 10.15C1.75098 5.72999 5.33498 2.14999 9.75598 2.14999H14.122C18.612 2.14999 22.251 5.78999 22.251 10.28C22.251 13.24 20.644 15.96 18.055 17.39L10.001 21.85V18.16H9.93398C5.44398 18.26 1.75098 14.65 1.75098 10.15ZM9.75598 4.14999C6.43898 4.14999 3.75098 6.83999 3.75098 10.15C3.75098 13.52 6.52098 16.23 9.88898 16.16L10.24 16.15H12.001V18.45L17.088 15.64C19.039 14.56 20.251 12.51 20.251 10.28C20.251 6.88999 17.507 4.14999 14.122 4.14999H9.75598Z" />
    </SvgIcon>
);
